import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AuthGate from './AuthGate.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import { QuotaProvider } from './context/QuotaContext.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <QuotaProvider>
          <AuthGate />
        </QuotaProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
